(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.js');
"use strict";

const clx = svs.components.lbUtils.clx;
const _svs$components$tipse = svs.components.tipsen.modularBase,
  WagerSkeletonDrawCard = _svs$components$tipse.WagerSkeletonDrawCard,
  WagerSkeletonCoupon = _svs$components$tipse.WagerSkeletonCoupon,
  WagerSkeletonSideNav = _svs$components$tipse.WagerSkeletonSideNav,
  WagerSkeletonResultCard = _svs$components$tipse.WagerSkeletonResultCard,
  WagerSkeletonWinGroups = _svs$components$tipse.WagerSkeletonWinGroups,
  WagerSkeletonReceipt = _svs$components$tipse.WagerSkeletonReceipt,
  WagerSkeletonButtons = _svs$components$tipse.WagerSkeletonButtons;
const WagerSkeleton = _ref => {
  let children = _ref.children,
    className = _ref.className;
  return React.createElement("div", {
    className: clx('pg_my_bets_wager_fallback', className)
  }, React.createElement("div", {
    className: "pg_my_bets_wager_fallback__grid"
  }, children));
};
WagerSkeleton.DrawCard = WagerSkeletonDrawCard;
WagerSkeleton.Coupon = WagerSkeletonCoupon;
WagerSkeleton.SideNav = WagerSkeletonSideNav;
WagerSkeleton.ResultCard = WagerSkeletonResultCard;
WagerSkeleton.WinGroups = WagerSkeletonWinGroups;
WagerSkeleton.Receipt = WagerSkeletonReceipt;
WagerSkeleton.Buttons = WagerSkeletonButtons;
setGlobal('svs.components.tipsen.modularBase.WagerSkeleton', WagerSkeleton);

 })(window);